module.exports = __webpack_public_path__ + "static/media/close-circle.7fe2970b.svg";